'use client';

import { COUNTRIES } from '@/lib/phone/countries';
import type { Country } from '@/lib/phone/countries';

interface CountryCodeSelectorProps {
  selectedCountry: Country;
  onChange: (country: Country) => void;
  disabled?: boolean;
}

/**
 * Dropdown selector for country dial codes with flag emojis.
 * Designed to be used as a prefix to phone number input fields.
 */
export default function CountryCodeSelector({
  selectedCountry,
  onChange,
  disabled = false,
}: CountryCodeSelectorProps) {
  return (
    <select
      value={selectedCountry.code}
      onChange={(e) => {
        const country = COUNTRIES.find(c => c.code === e.target.value);
        if (country) onChange(country);
      }}
      disabled={disabled}
      className="inline-flex items-center px-2 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary cursor-pointer"
      aria-label="Select country code"
    >
      {COUNTRIES.map((country) => (
        <option key={country.code} value={country.code}>
          {country.flag} +{country.dialCode}
        </option>
      ))}
    </select>
  );
}
